const noop = () => {}

// 旧通信库的 CONNECTING 分支只保留局部队列，open 后不会补发。
// 等原连接打开后再登记订阅；不另建连接，不覆盖库自身的事件处理器。
export function deviceStream (id, topic, parameter, transport = window) {
  if (typeof transport.getWebSocket !== 'function') throw new Error('实时通讯尚未初始化，请稍后重试')
  const get = transport.getWebSocket.bind(transport)
  // 兼容提供自有就绪机制的订阅实现；原生平台入口同时提供 initWebSocket。
  if (typeof transport.initWebSocket !== 'function') return get(id, topic, parameter)
  const init = transport.initWebSocket.bind(transport)
  return { subscribe (next = noop, error = noop, complete = noop) {
    let socket, inner, timer, closed = false, started = false
    const release = subscription => {
      if (subscription) { try { subscription.unsubscribe() } catch (_) { /* 关闭中的旧连接可能拒绝退订帧。 */ } }
    }
    const cleanup = () => {
      clearTimeout(timer)
      if (socket && typeof socket.removeEventListener === 'function') {
        socket.removeEventListener('open', start)
        socket.removeEventListener('error', failed)
        socket.removeEventListener('close', disconnected)
        socket.removeEventListener('message', serverMessage)
      }
    }
    const finish = cause => {
      if (closed) return
      closed = true; cleanup(); release(inner); inner = null
      if (cause) error(cause)
      else complete()
    }
    const failed = () => finish(new Error('实时通讯连接失败，请重连'))
    const disconnected = () => finish(new Error('实时通讯已断开，请重连实时属性'))
    // 旧Avue只打印error帧、随后把complete交给调用者，真实授权/协议错误会丢失。
    // 旁听本订阅的错误，不替换原处理器，也不影响其他组件的消息。
    function serverMessage (event) {
      let message
      try { message = JSON.parse(event.data) } catch (_) { return }
      if (!message || typeof message !== 'object') return
      if (message.requestId !== id || message.type !== 'error') return
      const cause = new Error(typeof message.message === 'string' ? message.message : '实时订阅被服务端拒绝')
      const status = Number(message.status || message.code || (message.payload && message.payload.status))
      if (Number.isInteger(status)) cause.status = status
      finish(cause)
    }
    function start () {
      if (closed || started || !socket || socket.readyState !== 1) return
      started = true; clearTimeout(timer)
      socket.removeEventListener('open', start)
      try {
        const subscription = get(id, topic, parameter).subscribe(
          message => { if (!closed) next(message) }, cause => finish(cause), () => finish())
        if (closed) release(subscription)
        else inner = subscription
      } catch (_) { failed() }
    }
    try {
      socket = init()
      if (!socket || ![0, 1].includes(socket.readyState) || typeof socket.addEventListener !== 'function' || typeof socket.removeEventListener !== 'function') {
        failed()
      } else {
        socket.addEventListener('open', start)
        socket.addEventListener('error', failed)
        socket.addEventListener('close', disconnected)
        socket.addEventListener('message', serverMessage)
        if (socket.readyState === 1) start()
        else timer = setTimeout(() => finish(new Error('实时通讯连接超时，请重连')), 10000)
      }
    } catch (_) { failed() }
    return { get closed () { return closed }, unsubscribe () {
      if (closed) return
      closed = true; cleanup(); release(inner); inner = null
    } }
  } }
}
